import PropTypes from 'prop-types'
import { useMultilingualService } from '../../../../service/multilingualService'
import USBModal from '../../../../components/modal-wrapper/index'
import './removeBillPopup.scss'
/**
 * Returns Remove bill popup
 * @method
 * @param {Boolean} openModal - flag value to oprn popup
 * @param {Function} closePopup - callback function to close popup
 * @param {Function} removeBill - handler to remove bill
 * @param {String} displayName - name of the biller
 * @returns {HTMLElement} Returns remove bill popup
 */
const RemoveBillPopup = ({
  openModal,
  closePopup,
  removeBill,
  displayName
}) => {
  const { REMOVEBILLPOPUP } = useMultilingualService('editBill')
  return (
    <div className="padding-columns">
      <USBModal
        wrapClassName="addBillConfirmPopup"
        contentClassName="billpay-modal"
        addClasses="small-modal"
        isOpen={openModal}
        modalTitle=""
        backdrop="static"
        handleModalClose={closePopup}
        wrapID="remove-bill-modal"
        zIndex="1050"
        data-test="modal-component"
        footerButtonOptions={[
          {
            type: 'primary',
            text: REMOVEBILLPOPUP.removebtn,
            id: 'ready-paybtn-yes-save',
            clickEvent: removeBill
          },
          {
            type: 'secondary',
            text: REMOVEBILLPOPUP.cancelbtn,
            id: 'ready-closebtn',
            clickEvent: closePopup
          }
        ]}
      >
        <h3 className="usb-tg-header-small usb-c-gray-90">
          {`${REMOVEBILLPOPUP.heading} ${displayName}?`}
        </h3>
      </USBModal>
    </div>
  )
}

RemoveBillPopup.propTypes = {
  openModal: PropTypes.bool.isRequired,
  closePopup: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  removeBill: PropTypes.func.isRequired
}

export default RemoveBillPopup
